import { useState, useEffect } from "react";
import { chevron_left, not_available_horizontal } from "../../pngs";
import { noFunc, getImg, privIsValidToken } from "../../utils";
import "./CoalitionComplements.scss";

export const CoalitionSpinner = () => (
  <div className="spinner">
    <div className="loading" />
  </div>
);

export const CoalitionProgressBar = ({ max, current }) => {
  return (
    <progress
      max={max}
      value={current}
      className={current >= max ? "ready" : ""}
    />
  );
};

export const CoalitionButton = ({
  label = "Button Label",
  style = {},
  klass = "",
  disabled = false,
  onClickEvent = (e) => noFunc("CoalitionButton", e),
  children,
}) => {
  return (
    <button
      type="button"
      className={`coalition-button ${klass}`}
      disabled={disabled}
      style={style}
      onClick={onClickEvent}
    >
      {children ? <>{children}</> : null}
      {label}
    </button>
  );
};

export const NavButton = ({ title, buttonClicked }) => (
  <>
    <CoalitionButton
      label={title}
      klass="nav-button"
      onClickEvent={buttonClicked}
    >
      {getImg(chevron_left, "back-icon")}
    </CoalitionButton>
  </>
);

export const PageButton = ({ buttonClicked }) => (
  <CoalitionButton
    label="Volver al Inicio"
    klass="coalition-button-go-dashboard"
    onClickEvent={buttonClicked}
  />
);

export const ImgLoader = ({ mobile, desktop }) => {
  return (
    <>
      <div className="product mobile">
        <SingleProductImg load={mobile} error={not_available_horizontal} />
      </div>
      <div className="product desktop">
        <SingleProductImg load={desktop} error={not_available_horizontal} />
      </div>
    </>
  );
};

export const SingleProductImg = ({ load, error }) => {
  const [product, setProduct] = useState();
  useEffect(() => {
    const testImg = (src, callback) => {
      let i = new Image();
      i.onload = () => callback(getImg(src));
      i.onerror = () => callback(getImg(error));
      i.src = src;
    };
    testImg(load, setProduct);
  }, [load, error]);
  return product;
};

export const isTokenValid = () => {
  const isValid = localStorage.getItem(privIsValidToken);
  return !(!isValid || isValid !== "true");
};
